import { WebLocale } from '@/enums/web-locale';
import { JWTVLP } from '@/lazy-load-components';
import { PageType } from '@/routing/config';
import { RouteRecordRaw } from 'vue-router';

export const rentalListLocales = [WebLocale.au, WebLocale.nz, WebLocale.uk, WebLocale.us] as const;
export const jwtvLpLocales = [WebLocale.au, WebLocale.nz];
export type RentalListLocale = (typeof rentalListLocales)[number];

export function makeRentalListRoutes(currentLocale: WebLocale): RouteRecordRaw[] {
	const routes: RouteRecordRaw[] = [];

	if (jwtvLpLocales.includes(currentLocale)) {
		routes.push(makeJwtvLPRoute(currentLocale as RentalListLocale));
	}

	return routes;
}

function makeJwtvLPRoute(currentLocale: RentalListLocale): RouteRecordRaw {
	return {
		name: 'app.jwtv.landing-page',
		path: `/${currentLocale}/watch`,
		component: JWTVLP,
		meta: {
			tab: 'watch',
			pageType: PageType.WATCH,
		},
	};
}
